import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import LocationsTable from "./LocationsTable";
import AddLocationModal from "./AddLocationModal";
import { getAccountManagers, getLocations, getParkingTypes, getThirdPartyPlatforms } from "helpers/fakebackend_helper";
import BulkLocationEdit from "./BulkLocationEdit";

const Locations = () => {
  document.title = "Locations | CurbDash";
  const user = JSON.parse(localStorage.getItem("authUser"));
  const [locations, setLocations] = useState([])
  const [accountManagers, setAccountManagers] = useState([])
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [thirdPartyPlatforms, setThirdPartyPlatforms] = useState([])
  const [parkingTypes, setParkingTypes] = useState([])

  const loadParkingTypes = async () => {
    const { data } = await getParkingTypes(user.token);
    setParkingTypes(data);
  }

  const loadThirdPartyPlatforms = async () => {
    const { data } = await getThirdPartyPlatforms(user.token);
    setThirdPartyPlatforms(data);
  }

  const loadLocations = async () => {
    const { data } = await getLocations(user.token);
    setLocations(data);
  }

  const loadAccountManagers = async () => {
    const { data } = await getAccountManagers(user.token);
    setAccountManagers(data);
  }

  useEffect(() => {
    loadLocations()
    loadAccountManagers()
    loadThirdPartyPlatforms()
    loadParkingTypes()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content" style={{ marginTop: -70, background: "rgb(38, 37, 35)" }}>
        <Container fluid>
          <Row className="d-flex justify-content-between align-items-center mb-4">
            <Col sm="auto">
              <Button
                className="button-gradient-bg"
                onClick={() => setIsAddModalOpen(!isAddModalOpen)}
              >
                Add Location
              </Button>
            </Col>
            <Col sm="auto">
              <BulkLocationEdit
                locations={locations}
                loadLocations={(bool) => bool && loadLocations(bool)}
                accountManagers={accountManagers}
              />
            </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <LocationsTable lots={locations} />
            </Col>
          </Row>
        </Container>
      </div>
      <AddLocationModal
        isOpen={isAddModalOpen}
        toggle={() => setIsAddModalOpen(!isAddModalOpen)}
        handleSave={() => {
          loadLocations()
          setIsAddModalOpen(false)
        }}
        thirdPartyPlatforms={thirdPartyPlatforms}
        parkingTypes={parkingTypes}
        accountManagers={accountManagers}
      />
    </React.Fragment>
  );
};

Locations.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Locations);
